import {
  createBaseAsyncHandlers,
  createKeyedAsyncReducer,
  initialState,
} from '../../../redux-util/async-helpers';
import { GET_GROUP } from '../../bridge-methods';
import { createReducer } from '../../../redux-util/general-helpers';

const singleFetchBase = createBaseAsyncHandlers(
  GET_GROUP,
  () => 'OMITTED. USE THE GROUP LIST.'
);

export default createKeyedAsyncReducer({
  actionKeys: GET_GROUP,
  param: 'id',
  itemReducer: createReducer(initialState, singleFetchBase),
});
